import styled from "styled-components";
import { useDashboardContext } from "../../../context/dashboard_context";
import { lowstock } from "../../../assets";
import { ICON_EXCLAMATION } from "../../../utils/icons";


const LowQuatityStock = () => {

      const { dashboardData } = useDashboardContext();

      const { lowStock } = dashboardData;
      if (!lowStock) {
            return (
                  <StyledLowQuatityStock>
                        <div className="main-container">
                              <h4 className="mb-4 grey-bold-text">
                                    Low  Quantity Stock
                              </h4>

                              <div className="d-flex align-items-center justify-content-center my-5">
                                    <div className="text-center grey-text">
                                          <h1 className="text-md">
                                                {ICON_EXCLAMATION}
                                          </h1>
                                          <p className="">
                                                No items available
                                          </p>
                                    </div>
                              </div>
                        </div>


                  </StyledLowQuatityStock>
            );
      }



      return (
            <StyledLowQuatityStock>
                  <div className="main-container">
                        <h4 className="mb-4 grey-bold-text">
                              Low  Quantity Stock
                        </h4>

                        <div className="">
                              {lowStock?.map(({ invtid, qty, itemName, }, i) =>
                                    <div className="d-flex align-items-center mb-3"
                                          key={invtid}
                                    >
                                          <div className="text-center col-md-3">
                                                <img src={lowstock} alt="Item" width="50px" />
                                          </div>
                                          <div className="col-md-7">
                                                <h6 className="m-0 fw-bold">
                                                      {itemName}
                                                </h6>
                                                <small className="grey-light-text">
                                                      Remaining Quantity : {qty} Packet
                                                </small>
                                          </div>
                                          <div className="text-center col">
                                                <div className="badge badge-danger br-md">
                                                      Low
                                                </div>
                                          </div>
                                    </div>
                              )}
                        </div>



                  </div>


            </StyledLowQuatityStock>
      );
};

export default LowQuatityStock;

const StyledLowQuatityStock = styled.div`
      


`;